import React, { useEffect, useState } from 'react';
import { Box, ButtonBase, makeStyles, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import _ from 'lodash';
import TableUI from '../../../../../components/TableUI';
import { Checkbox } from '../../../../DutyAssign/components/Attendance/Setting';
import Text from '../../../../../components/Text';
import { DeleteIcon, UploadIcon } from '../../../../../components/Icon';
import { ReactComponent as DropdownBtnIcon } from '../../../../../static/images/DropdownBtnIcon.svg';
import { ReactComponent as DropupBtnIcon } from '../../../../../static/images/DropupBtnIcon.svg';
import { eadmissionAPI } from '../../../../../apis';
import { alertMsg } from '../../../../../apis/commlogic';
import { ADMISSION_SETTING_MAPPING } from '../../../../../comm/constant';
import { onKeyUpEnterOrSpace, getRealBash64Str } from '../../../../../utils';
import { convertFile } from '../../../../../utils/hooks/useUploadFile';

const ActionableAlert = () => {
  const classes = useStyles();
  const [detailCtrl, setDetailCtrl] = useState({
    AED: true,
    'Bed Coordinator': true,
    'Admission Office': true,
    Ward: true,
    AudioFile: true,
  });
  const [data, setData] = useState({
    AED: [],
    AudioFile: [],
    'Bed Coordinator': [],
    Ward: [],
    'Admission Office': [],
  });
  const [uploadId, setUploadId] = useState(null);

  const getActionableAlertList = async () => {
    try {
      const { result } = await eadmissionAPI.getActionableAlertList();
      setData(result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getActionableAlertList();
  }, []);

  const deleteAudioFile = (audioFileId) => async () => {
    try {
      await eadmissionAPI.deleteAudioFile({ audioFileId });
      getActionableAlertList();
    } catch (error) {
      console.log(error);
    }
  };

  const uploadAudioFile = async ({ audioFileDesc, fileName, fileSize, mineType }) => {
    try {
      const params = {
        audioFileDesc,
        audioFileId: uploadId,
        fileName,
        fileSize,
        fileType: 'FILE',
        mineType,
      };
      await eadmissionAPI.uploadAudioFile(params);
      getActionableAlertList();
    } catch (error) {
      console.log(error);
    }
  };

  const handleUpload = (event) => {
    console.log('uploadId', uploadId);
    const file = event.target.files[0];
    console.log('file', file);
    if (file) {
      const audio = document.createElement('audio');
      audio.src = URL.createObjectURL(file);

      audio.addEventListener('loadedmetadata', async function () {
        const duration = audio.duration;
        console.log('duration', duration);
        // 清理对象URL
        URL.revokeObjectURL(audio.src);

        // 处理逻辑：例如，如果时长超过15秒，可以显示警告信息
        if (duration > 15) {
          alertMsg('音频文件时长超过15秒，请选择更短的文件。', 'upload file', 'error');
        } else {
          try {
            // 执行上传操作
            const tmpbase64 = await convertFile(file);
            const realbase64 = getRealBash64Str(tmpbase64);
            uploadAudioFile({
              audioFileDesc: realbase64,
              fileName: file.name,
              fileSize: file.size,
              mineType: file.type,
            });
          } catch (error) {
            console.log(error);
          }
        }
      });
    }
  };

  const updateActionableAlertList = async ({ hospActionableAlertId, isAck, isShow }) => {
    try {
      const params = {
        hospActionableAlertId,
        isAck,
        isShow,
      };
      await eadmissionAPI.updateActionableAlertList(params);
      getActionableAlertList();
    } catch (error) {
      console.log(error);
    }
  };

  const handleToggleDetail = (key) => {
    setDetailCtrl((preDetail) => ({
      ...preDetail,
      [key]: !preDetail[key],
    }));
  };

  return (
    <Box display="flex" flexDirection="column">
      {_.map(detailCtrl, (open, key) => (
        <Box display="flex" flexDirection="column" mb={open ? '1.87rem' : ''} key={key}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={key === 'AudioFile' ? '0.5rem' : '1.56rem'}
          >
            <Text fontSize="1.5rem" color="#333333" fontFamily="NotoSans-Bold">
              {key}
            </Text>
            <ButtonBase onClick={() => handleToggleDetail(key)}>
              {open ? <DropupBtnIcon className={classes.dropIcon} /> : <DropdownBtnIcon className={classes.dropIcon} />}
            </ButtonBase>
          </Box>
          {open && key === 'AudioFile' && (
            <Box mb="1.88rem">
              <Text fontSize="1rem" color="#7D86A9">
                {`Audio file (<= 15 sec.)`}
              </Text>
            </Box>
          )}
          {open && (
            <TableUI>
              <TableHead className={classes.tableHeader}>
                <TableRow>
                  <TableCell style={{ width: '80%' }}>Actionable alert</TableCell>
                  <TableCell style={{ width: '10%' }}>{key === 'AudioFile' ? '' : 'Is show'}</TableCell>
                  <TableCell style={{ width: '10%' }}>{key === 'AudioFile' ? '' : 'is ack. req.'}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody className={classes.tableBody}>
                {data?.[key]?.map((item) => (
                  <TableRow key={item.hospActionableAlertId ?? item.audioFileId}>
                    <TableCell>{ADMISSION_SETTING_MAPPING[item.actionableAlert]}</TableCell>
                    <TableCell>
                      {key !== 'AudioFile' && item.isShow !== null && (
                        <Checkbox
                          check={Boolean(item.isShow)}
                          handleChange={() =>
                            updateActionableAlertList({
                              hospActionableAlertId: item.hospActionableAlertId,
                              isShow: item.isShow === 0 ? 1 : 0,
                              isAck: item.isAck,
                            })
                          }
                        />
                      )}
                    </TableCell>
                    <TableCell className={key === 'AudioFile' ? classes.audioCell : ''}>
                      {key === 'AudioFile' &&
                        (item.audioFile ? (
                          <Box display="flex" alignItems="center" gridGap="0.69rem">
                            <div className={classes.fileName}>{`[${item.fileName}]`}</div>
                            <ButtonBase className={classes.upload} onClick={deleteAudioFile(item.audioFileId)}>
                              <DeleteIcon className={classes.icon} />
                            </ButtonBase>
                          </Box>
                        ) : (
                          <label
                            className={classes.upload}
                            htmlFor="file"
                            onClick={() => setUploadId(item.audioFileId)}
                            tabIndex={0}
                            onKeyUp={(e) => onKeyUpEnterOrSpace(e, () => setUploadId(item.audioFileId))}
                          >
                            <UploadIcon className={classes.icon} />
                          </label>
                        ))}

                      {key !== 'AudioFile' && item.isAck !== null && (
                        <Checkbox
                          check={Boolean(item.isAck)}
                          handleChange={() =>
                            updateActionableAlertList({
                              hospActionableAlertId: item.hospActionableAlertId,
                              isShow: item.isShow,
                              isAck: item.isAck === 0 ? 1 : 0,
                            })
                          }
                        />
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </TableUI>
          )}
        </Box>
      ))}
      <input
        type="file"
        name="file"
        id="file"
        // accept={fileType.join(',')}
        onChange={handleUpload}
        className={classes.inputfile}
        onClick={(event) => {
          event.target.value = '';
        }}
      />
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  tableHeader: {
    '& .MuiTableCell-head': {
      fontSize: '1rem !important',
      padding: '0 0 1.19rem !important',
    },
  },
  tableBody: {
    '& .MuiTableCell-body': {
      fontSize: '1.125rem !important',
      padding: '1rem 0 !important',
    },
  },
  icon: {
    fontSize: '1.5rem',
    color: '#538FFF',
  },
  dropIcon: {
    width: '3rem',
    height: '3rem',
  },
  inputfile: {
    width: '0.1px',
    height: '0.1px',
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    zIndex: -1,
  },
  audioCell: {
    '&.MuiTableCell-root': {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingRight: '1.5rem !important',
    },
  },
  upload: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    width: '2.25rem',
    height: '2.25rem',
    borderRadius: '0.5rem',
    border: '1px #538FFF solid',
  },
  fileName: {
    color: '#538FFF',
    fontSize: '1.125rem',
  },
}));

export default ActionableAlert;
